<template>
	<div class="message">
		<div class="header">
			<div>{{ sent_datetime }}</div>
			<div>{{ reading_datetime }}</div>
		</div>
		<div class="body">{{ model.message }}</div>
		<button v-if="model.attachment" @click="playAudio" class="btn btn-small btn-round btn-primary">Play message</button>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'model'
	],
	data () {
		return {
			metadata: new ApiObject(),
			blob: null
		}
	},
	computed: {
		sent_datetime () {
			return ''
		},
		reading_datetime () {
			let date = this.model.reading_time
			return date ? 'seen: ' + this.$moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
		},
		message () {
			return this.model.message
		}
	},
	methods: {
		downloadAttachment () {
			return this.$api.files.get(this, this.user_uid, this.watch_id, this.model.attachment, 'audio/mpeg')
				.then(response => {
					this.$log.info('watch chat message', 'files.get OK', response)()
					let arrayBuffer = response.body
					this.blob = new Blob([arrayBuffer], { type: 'application/download' })
				}).catch(error => {
					this.$log.error('watch chat message', 'files.get ERROR', error)()
				})
		},
		playMedia () {
			const ctx = new AudioContext()
			const fileReader = new FileReader()
			fileReader.onload = e =>  ctx.decodeAudioData(fileReader.result)
				.then(buf => {
					const source = ctx.createBufferSource()
					source.buffer = buf
					source.connect(ctx.destination)
					source.start(0)
				})
			fileReader.readAsArrayBuffer(this.blob)
		},
		playAudio () {
			if (this.model.attachment) {
				this.blob ? this.playMedia() : this.downloadAttachment().then(() => { this.playMedia() })
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/chat/Message.vue